// MUI v9: prefixo "pi-" nas classes, para isolá-las das classes globais do v4 durante a migração.
// Precisa ser o PRIMEIRO import (antes de qualquer componente do @mui/material ser carregado).
import "theme/mui9/configureClassNames";
import React from "react";
import "./i18n";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import { persistor, store } from "./store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Suspense } from "react";

import { AuthProvider } from "./connections/auth/AuthProvider";
import AuthLayout from "layouts/auth/auth.js";
import MainLayout from "./layouts/main/main.js";
import WelcomeLayout from "./layouts/welcome/welcome.js";
import ExtrasLayout from "./layouts/extras/extras.js";
import LogOut from "./logout";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./connections/auth/AuthConfig";

// CSS Configurations
import "assets/scss/material-dashboard-pro-react.scss?v=1.10.0";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "assets/theme.js";
import AppThemeProvider from "theme/mui9/AppThemeProvider";

const root = createRoot(document.getElementById("root"));
const msClientId = "27919373-3c5d-433c-ac5c-9d6c9dc4dcb7";
const msalInstance = new PublicClientApplication(msalConfig(msClientId));
const googleClientId =
  "326066756623-dl18bv8vgl16idvgj3if5u87qj99l8ol.apps.googleusercontent.com";

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={null}>
          <AuthProvider>
            <MsalProvider instance={msalInstance}>
              <GoogleOAuthProvider clientId={googleClientId}>
                {/* Tema v9 (cor da implementação) por fora; tema v4 por dentro até o fim da fase 3 */}
                <AppThemeProvider>
                  <ThemeProvider theme={theme}>
                    <Switch>
                      <Route path="/auth" component={AuthLayout} />
                      <Route path="/main" component={MainLayout} />
                      <Route path="/welcome" component={WelcomeLayout} />
                      <Route path="/extras" component={ExtrasLayout} />
                      <Route path="/logout" component={LogOut} />
                      <Redirect from="/" to="/main/cockpit" />
                    </Switch>
                  </ThemeProvider>
                </AppThemeProvider>
              </GoogleOAuthProvider>
            </MsalProvider>
          </AuthProvider>
        </Suspense>
      </PersistGate>
    </Provider>
  </BrowserRouter>,
);
